import { useState, useEffect } from "react";
import {
  Grid,
  Toolbar,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useStyle } from "./Freebar.style";
import usePricingModal from "../../hooks/usePricingModal";

export const FreeBar = () => {
  const classes = useStyle();
  const { modalComponent, togglePricingModal } = usePricingModal();

  const [isVisible, setIsVisible] = useState(true);

  const theme = useTheme();

  const smallDisplay = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const listenToScroll = () => {
      const heightToHideFrom = 20;
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (winScroll > heightToHideFrom && isVisible) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, [isVisible]);

  return (
    <>
      <Toolbar
        className={classes.freeBar}
        onClick={smallDisplay ? togglePricingModal : null}
      >
        <Grid container direction="row" alignItems="center">
          <Grid item lg={10} md={9} xs={11}>
            <Typography className={classes.text}>
              Equip yourself to achieve financial freedom. Unlock everything
              Fruition has to offer!
            </Typography>
          </Grid>
          <Grid item lg={2} md={3} xs={1}>
            <Grid container justifyContent="center">
              <Button
                type="button"
                endIcon={<ChevronRightIcon />}
                onClick={togglePricingModal}
              >
                <span className={classes.hideOnSm}>Learn more</span>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
      {modalComponent}
    </>
  );
};
